module.exports = __webpack_public_path__ + "static/img/6.8dbd079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/6.png
// module id = tjyC
// module chunks = 0